module.exports = __webpack_public_path__ + "img/facebook.72bb507e.png";